var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumOrganization = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 1,
    y2: 1.122,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37c7f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933",
    transform: "translate(-48 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M5340,3835a22,22,0,1,0,15.556,6.444A21.855,21.855,0,0,0,5340,3835m0-5a27,27,0,1,1-27,27A27,27,0,0,1,5340,3830Z",
    transform: "translate(-5265 -3789)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M5015.04,3828.055a1.632,1.632,0,0,1-1.3-.629,1.771,1.771,0,0,1-.309-1.509,7.253,7.253,0,0,1,3.319-4.462,10.866,10.866,0,0,1,10.81-.023,7.209,7.209,0,0,1,3.323,4.489,1.77,1.77,0,0,1-.312,1.508,1.629,1.629,0,0,1-1.292.626Zm.435-2h13.375c-.939-2.981-4.15-4.05-6.688-4.05S5016.428,3823.074,5015.475,3826.055Zm16.834.271a1,1,0,0,1,0-2h5.433c-.829-2.078-3.181-2.832-5.054-2.832a6.554,6.554,0,0,0-2.771.528,1,1,0,1,1-.832-1.819,9.122,9.122,0,0,1,8.027.479,5.987,5.987,0,0,1,2.741,3.686,1.616,1.616,0,0,1-.285,1.38,1.5,1.5,0,0,1-1.191.578Zm-26.046,0a1.5,1.5,0,0,1-1.193-.578,1.621,1.621,0,0,1-.285-1.377,5.993,5.993,0,0,1,2.742-3.688,9.122,9.122,0,0,1,8.027-.479,1,1,0,0,1-.833,1.819,6.549,6.549,0,0,0-2.77-.528c-1.873,0-4.226.754-5.056,2.832h5.433a1,1,0,1,1,0,2Zm22.564-11.628a3.914,3.914,0,0,1,1.009-2.993,3.98,3.98,0,0,1,5.707-.008,3.925,3.925,0,0,1,1,3,3.866,3.866,0,1,1-7.721,0Zm2.474-1.631a1.938,1.938,0,0,0-.479,1.486,1.892,1.892,0,1,0,3.731,0,1.928,1.928,0,0,0-.473-1.494,1.982,1.982,0,0,0-2.779.006Zm-23.212,1.629a3.931,3.931,0,0,1,1.006-3,3.979,3.979,0,0,1,5.706.008,3.917,3.917,0,0,1,1.011,2.993,3.866,3.866,0,1,1-7.722,0Zm2.469-1.635a1.924,1.924,0,0,0-.473,1.5,1.892,1.892,0,1,0,3.731,0,1.944,1.944,0,0,0-.479-1.486,1.982,1.982,0,0,0-2.779-.006Zm8.479,4.046a5.534,5.534,0,0,1-1.44-3.38,4.648,4.648,0,0,1,1.179-3.547,4.741,4.741,0,0,1,6.765.009,4.628,4.628,0,0,1,1.183,3.539,5.54,5.54,0,0,1-1.441,3.378,4.106,4.106,0,0,1-6.245,0Zm1.2-5.563a2.629,2.629,0,0,0-.646,2.042c.114,1.6,1.289,2.961,2.568,2.961a2.3,2.3,0,0,0,1.658-.8,3.553,3.553,0,0,0,.911-2.16,2.655,2.655,0,0,0-.654-2.032,2.747,2.747,0,0,0-3.836-.008Z",
    transform: "translate(-4947.319 -3751.055)",
    fill: "url(#linear-gradient-2)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumOrganization, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-organization.1a97acaf.svg";
export { ForwardRef as ReactComponent };